import * as React from "react";
import {PastCaseProject} from "src/domain/model/past_case_project";
import {routeConfig} from "../../../../config/language/ja-JP/presentation/route_text";
import {Customer} from "../../../../domain/model/customer";
import {JobCareer} from "../../../../domain/model/job_career";
import PageWrapper from "../../../common/atom/wrapper/page_wrapper";
import Breadcrumbs from "../../../common/molecular/breadcrumbs/breadcrumbs";
import Progress from "../../../common/organism/progress";
import {TBreadcrumbItem} from "../../../type/common";
import CustomerMypageMainCustomer from "./info/customer_mypage_main_customer";
import Faq from "../../faq";

interface IProps {
    isLoading: boolean;
    customer: Customer | null;
    jobCareers: JobCareer[];
    pastCaseProjects: PastCaseProject[];
}

const CustomerMyPageInfoComponent: React.FC<IProps> = (props) => {
    const {isLoading, customer, jobCareers, pastCaseProjects} = props;

    const breadcrumbItems: TBreadcrumbItem[] = [
        routeConfig.customerRoot,
        routeConfig.customerMypage,
    ];

    return (
        <React.Fragment>
            {isLoading && <Progress canAnimation={false}/>}

            <PageWrapper>
                <Breadcrumbs breadcrumbItems={breadcrumbItems}/>
                <Faq title={"プロフィールページの登録"}
                     text={"プロフィールページの登録は、ベース情報、職務経歴、希望条件の3つの主要セクションで構成されています。各セクションは専用の編集ボタンから入力可能で、AIを活用して自己PRや職務要約を生成することもできます。過去の案件例も含めた詳細な情報入力が推奨されています。"}
                     link={"https://branch-saturn-9ef.notion.site/170b91fe393e8038981cc417f371382c"}/>
                {/*<PageTopInfo*/}
                {/*    information={pageTopInfoConfig.customerMypage}*/}
                {/*    linkURL={OuterURL.customerMypageFaqURL}*/}
                {/*/>*/}
                <CustomerMypageMainCustomer
                    customer={customer}
                    jobCareers={jobCareers}
                    pastCaseProjects={pastCaseProjects}
                />
            </PageWrapper>
        </React.Fragment>
    );
};

export default CustomerMyPageInfoComponent;



// WEBPACK FOOTER //
// ./src/presentation/component/customer/mypage/customer_mypage_info.tsx